/**
 * 浏览器扩展发布服务
 */
import { apiService } from '@/services/api'
import type {
  ExtensionLatestRelease,
  ExtensionLatestReleaseApiResponse,
} from '@/types/extensionRelease'

/**
 * 获取客户端最新发布信息。
 * @param channel 发布通道
 * @returns 最新发布信息
 */
export async function getLatestExtensionRelease(
  channel = 'stable'
): Promise<ExtensionLatestRelease> {
  const response = await apiService.get<ExtensionLatestReleaseApiResponse>('/api/client-update/latest', {
    channel,
  })
  return response.data
}
